import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { hasCustomClaim, redirectUnauthorizedTo, redirectLoggedInTo } from '@angular/fire/auth-guard';
import { canActivate } from '@angular/fire/auth-guard';

const redirectUnauthorizedToLogin = () => redirectUnauthorizedTo(['login']);
const redirectLoggedInToMenus = () => redirectLoggedInTo(['menu']);

const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule),
    ...canActivate(redirectLoggedInToMenus)
  },
  {
    path: 'menu',
    loadChildren: () => import('./menu/menu.module').then( m => m.MenuPageModule),
    ...canActivate(redirectUnauthorizedToLogin) 
  },      
  {
    path: 'add-property',
    loadChildren: () => import('./alagbe/modals/add-property/add-property.module').then( m => m.AddPropertyPageModule)
  },
  {
    path: 'add-team',
    loadChildren: () => import('./alagbe/modals/add-team/add-team.module').then( m => m.AddTeamPageModule)
  },
  {
    path: 'add-location',
    loadChildren: () => import('./alagbe/modals/add-location/add-location.module').then( m => m.AddLocationPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
